import http from "./httpServices";
import { jwtDecode } from "jwt-decode";

const tokenKey = "token";

function getStoredToken() {
  return sessionStorage.getItem(tokenKey) || localStorage.getItem(tokenKey);
}

export async function login(data) {
  const res = await http.post("/login.php", data);
  sessionStorage.setItem(tokenKey, res.data.jwt);
  return res.data;
}

export function logout() {
  const user = getCurrentUser();

  if (user?.data?.id && user?.data?.type) {
    http
      .post("/logout.php", {
        userId: user.data.id,
        userType: user.data.type,
        sessionToken: user.data.sessionToken,
      })
      .catch((err) => {
        console.error("Logout API error:", err);
      });
  }

  sessionStorage.removeItem(tokenKey);
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const jwt = getStoredToken();
    if (!jwt) return null;

    const decoded = jwtDecode(jwt);

    if (decoded?.exp && decoded.exp * 1000 <= Date.now()) {
      sessionStorage.removeItem(tokenKey);
      localStorage.removeItem(tokenKey);
      return null;
    }

    return decoded;
  } catch (err) {
    sessionStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenKey);
    return null;
  }
}

export async function register(data) {
  const res = await http.post("/register.php", data);
  return res.data;
}

export async function requestPasswordReset(data) {
  const res = await http.post("/requestPasswordReset.php", data);
  return res.data;
}

export async function resetPassword(data) {
  const res = await http.post("/resetPassword.php", data);
  return res.data;
}

export async function deleteUser(utilizadorId) {
  const res = await http.post("/delete_user.php", { id: utilizadorId });
  return res.data;
}

export async function editUser(data) {
  const res = await http.post("/edit_user.php", data);
  return res.data;
}

export async function checkEmail(params) {
  try {
    const { data } = await http.post("/check_email.php", params);
    return data;
  } catch (err) {
    console.error("Error checking email:", err);
    return [];
  }
}

export async function refreshSession() {
  const user = getCurrentUser();

  if (!user?.data?.id || !user?.data?.type || !user?.data?.sessionToken) {
    return null;
  }

  try {
    const res = await http.post("/refreshSession.php", {
      userId: user.data.id,
      userType: user.data.type,
      sessionToken: user.data.sessionToken,
    });
    return res?.data || null;
  } catch (err) {
    return null;
  }
}

const auth = {
  login,
  logout,
  getCurrentUser,
  register,
  requestPasswordReset,
  resetPassword,
  deleteUser,
  editUser,
  checkEmail,
  refreshSession,
};

export default auth;
